/* eslint-disable react/display-name */
import styles from './DealCard.module.css'
import Linked from 'shared-components/service/Linked'
import clsx from 'clsx'
import { BasicStyledComponent, DSDeal } from 'shared-definitions/types'
import AppImage from 'shared-components/ui/AppImage'
import Score from 'shared-components/ui/Score'
import DiscountBadge from 'shared-components/deals/DiscountBadge'
import React from 'react'
import EditButton from 'shared-components/service/EditButton'
import { priceFormat, wrapWithCurrency } from 'shared-code/format'
import { AppEventsContext } from '../contexts/AppEventsContext'

interface DealCardProps extends BasicStyledComponent {
  deal: DSDeal
  variant: 'default' | 'hot'
}

const DealCard: React.VFC<DealCardProps> = React.memo(({ className, deal, variant }) => {
  const { appEvent } = AppEventsContext.useContainer()
  return (
    <div
      className={clsx(styles.container, className, {
        [styles.variantDefault]: variant === 'default',
        [styles.variantHot]: variant === 'hot',
      })}
    >
      <EditButton pLink={deal.pLinkEdit} elevated pLinkRequestUpdate={null} />
      <Linked
        onClick={() => {
          appEvent({
            event: 'widget-interaction',
            widgetType: 'Deals Widget',
            label: deal.buttonText,
            url: deal.pLink.href,
          })
        }}
        {...deal.pLink}
        className={clsx(styles.linked, { [styles.missingImage]: !deal.image })}
      >
        {deal.image ? (
          <>
            <AppImage
              className={styles.image}
              layout="responsive"
              ratio={{ w: 16, h: 9 }}
              image={deal.image}
              sizes={[
                { bp: 'xl', val: 243 },
                { bp: 'md', val: 'calc(50vw - rem(70))' },
                'calc(100vw - rem(70))',
              ]}
            />
            <DiscountBadge price={deal.price} className={styles.discountBadge} />
          </>
        ) : null}

        {deal.score ? <Score className={styles.score} score={deal.score} /> : null}

        <div className={styles.dealAdded}>{deal.added}</div>
        <div className={styles.buttonContainer}>
          <div className={styles.buttonOverlay}>
            <div className={styles.button}>
              {deal.buttonText} {deal.store ? `at ${deal.store}` : ''}
            </div>
          </div>
          {deal.title && <div className={styles.title}>{deal.title}</div>}

          {(deal.price.discount || deal.price.coupon || deal.price.customText) && (
            <div className={styles.dealDetails}>
              {deal.price.discount && (
                <p>
                  {'Save '}
                  <span className={styles.savedAmount}>{`${wrapWithCurrency(
                    priceFormat(deal.price.discount),
                    deal.price.currency
                  )}`}</span>
                </p>
              )}

              {deal.price.discount && (deal.price.coupon || deal.price.customText) && (
                <span className={styles.detailsDivider}>{'|'}</span>
              )}

              {deal.price.coupon && (
                <p>
                  {'Use code:'}
                  <span className={styles.couponCode}> {deal.price.coupon}</span>
                </p>
              )}
              {deal.price.customText && (
                <p>
                  <span className={styles.couponCode}> {deal.price.customText}</span>
                </p>
              )}
            </div>
          )}
        </div>
      </Linked>
    </div>
  )
})

export default DealCard
